import { render } from "./WoolItem.vue?vue&type=template&id=e19ad89e&scoped=true"
import script from "./WoolItem.vue?vue&type=script&lang=js"
export * from "./WoolItem.vue?vue&type=script&lang=js"

import "./WoolItem.vue?vue&type=style&index=0&id=e19ad89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19ad89e"]])

export default __exports__